import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import FormStepWrapper from 'components/form/FormStepWrapper';
import LocationField from 'components/location/picker/LocationField';
import { LocationPickerStep } from 'components/location/picker/LocationPickerStep';
import { useAddItem } from 'features/add-item/context/AddItemProvider';
import { useCurrentUser } from 'providers/cache/cachedDataHooks';
import { fromUserLocation } from 'services/utils/location/locationPicker.utils';

const SetServiceLocation = () => {
  const { t } = useTranslation('addItem');
  const { formData, errors, setFieldValue, isEditMode } = useAddItem();
  const { currentUser } = useCurrentUser();
  const [isPickingLocation, setIsPickingLocation] = useState(false);

  useEffect(() => {
    if (isEditMode || formData.itemLocation) return;
    const profileLocation = fromUserLocation(currentUser?.location);
    if (profileLocation) setFieldValue('itemLocation', profileLocation);
  }, [isEditMode, formData.itemLocation, currentUser?.location, setFieldValue]);

  if (isPickingLocation) {
    return (
      <LocationPickerStep
        defaultLocation={formData.itemLocation}
        onCancel={() => setIsPickingLocation(false)}
        onConfirm={location => {
          setFieldValue('itemLocation', location);
          setIsPickingLocation(false);
        }}
      />
    );
  }

  return (
    <FormStepWrapper
      header={t('delivery.service.header')}
      description={t('delivery.service.description')}
      isValid={!errors.itemLocation}>
      <LocationField
        mode='step'
        value={formData.itemLocation}
        onChange={value => setFieldValue('itemLocation', value)}
        onOpenStep={() => setIsPickingLocation(true)}
        placeholder={t('common:set-location')}
      />
    </FormStepWrapper>
  );
};

export default SetServiceLocation;
